import React, { PureComponent } from 'react'
import { node, string, bool } from 'prop-types'

import Panel from './AccordionPanel'
import KEY_CODES from '../../shared/utils/keyCodes'

export class Accordion extends PureComponent {
  static propTypes = {
    className: string,
    children: node.isRequired,
    multiSelectable: bool,
    transition: string,
  }

  _focusableChildren = []

  static defaultProps = {
    className: '',
    multiSelectable: false,
    transition: 'height 0.2s ease',
  }

  constructor(props) {
    super(props)
    this.state = {
      status: {},
    }
  }

  setStatus = (key, active) => {
    const { multiSelectable, children } = this.props
    this.setState(prvState => {
      const newStatus = {}
      if (multiSelectable) {
        newStatus[key] = active
      } else {
        React.Children.forEach(children, (_child, k) => {
          newStatus[k] = false
        })
        newStatus[key] = active
      }
      return {
        status: {
          ...prvState, ...newStatus,
        },
      }
    })
  }

  handleInitChildren = (_index, children) => {
    if (!this._focusableChildren) {
      this._focusableChildren = []
    }
    if (children) {
      this._focusableChildren = [...this._focusableChildren, children]
    } else {
      this._focusableChildren = [...this._focusableChildren]
    }
  }

  handleChildChangeFocus = (index, active, keyCode, children, disabled) => {
    const currentIndex = this._focusableChildren.indexOf(children)
    const maxIndex = this._focusableChildren.length - 1

    switch (keyCode) {
      case KEY_CODES.ENTER:
      case KEY_CODES.SPACE:
        if (!disabled) {
          this.setStatus(index, active)
        }
        break
      case KEY_CODES.DOWNARROW:
        children.blur()
        this._focusableChildren[
          currentIndex + 1 >= maxIndex ? maxIndex : currentIndex + 1
        ].focus()
        break
      case KEY_CODES.UPARROW:
        children.blur()
        this._focusableChildren[currentIndex - 1 <= 0 ? 0 : currentIndex - 1].focus()
        break
      default:
        break
    }
  }

  render() {
    const { status } = this.state
    const { children, transition, className } = this.props
    const items = []

    React.Children.map(children, (child, key) => {
      const item = React.cloneElement(child, {
        key,
        index: key,
        active: status[key] !== undefined ? status[key] : child.props.active,
        transition: transition,
        onInitChildren: this.handleInitChildren,
        setStatus: this.setStatus,
        onChangeFocus: this.handleChildChangeFocus,
      })

      items.push(item)
    })

    return (
      <div className={`accordion-group ${className || ''}`}>
        {items}
      </div>
    )
  }
}

Accordion.Panel = Panel

export default Accordion
